import { WarningCircle } from "@phosphor-icons/react"
import { Button, Modal, Tag } from "@vesatogo/grass-core"
import { useEffect, useState } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import { AppRoutes } from "~/constants/routes"
import { useAllStorageLocationAlertsQuery } from "~/generated/graphql"

export const AgreementRenewAlertModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [{ data }] = useAllStorageLocationAlertsQuery({
    requestPolicy: "network-only",
  })
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (
      data?.all_storage_location_alerts?.length &&
      location.state?.fromSidebar
    ) {
      setIsOpen(true)
      // Clear the fromSidebar state so it doesn't show again on back navigation or refresh
      navigate(location.pathname + location.search, {
        replace: true,
        state: { ...location.state, fromSidebar: false },
      })
    }
  }, [data, location.state, location.pathname, location.search, navigate])

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Renew Agreement"
      bodyClassName="max-w-md"
      contentClassName="max-h-[calc(100vh-20rem)] overflow-y-auto"
    >
      <div className="flex flex-col gap-4">
        <div className="h-2 bg-yellow-400 !mx-4" />
        <div className="flex justify-center mt-4">
          <div className="bg-yellow-100 p-4 rounded-full">
            <WarningCircle
              size={60}
              weight="fill"
              className="text-yellow-500"
            />
          </div>
        </div>

        <div className="flex flex-col gap-3 px-2">
          {data?.all_storage_location_alerts?.map((alert, idx) => {
            if (!alert) return null
            return (
              <Link
                key={idx}
                className="bg-[#EEF2FF] p-3 rounded-lg flex justify-between items-center cursor-pointer border border-[#E0E7FF]"
                to={
                  alert.storage_location?.id
                    ? AppRoutes.storageLocationDetail(alert.storage_location.id)
                    : ""
                }
              >
                <div className="flex gap-2 text-sm text-[#0F172A]">
                  <span>{idx + 1}.</span>
                  <span className="underline">{`${alert.storage_location?.name}`}</span>
                </div>
                <Tag variant="outline" intent="info" className="!rounded-full">
                  {alert.storage_location?.agreements?.[0]?.expiry_alert_days
                    ? `${alert.storage_location.agreements[0].expiry_alert_days} days`
                    : "Expiring"}
                </Tag>
              </Link>
            )
          })}
        </div>

        <div className="px-6 pb-2 text-center">
          <p className="text-[#475569]">
            Please renew the agreement before the expiry date to avoid service
            interruption.
          </p>
        </div>

        <div className="px-6 pb-6">
          <Button
            variant="outline"
            className="w-full !border-green-400 !text-green-600 hover:!bg-green-50"
            onClick={() => setIsOpen(false)}
          >
            Later
          </Button>
        </div>
      </div>
    </Modal>
  )
}
